import { render, staticRenderFns } from "./AITemplate.vue?vue&type=template&id=5d85fd26&scoped=true"
import script from "./AITemplate.vue?vue&type=script&lang=js"
export * from "./AITemplate.vue?vue&type=script&lang=js"
import style0 from "./AITemplate.vue?vue&type=style&index=0&id=5d85fd26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85fd26",
  null
  
)

export default component.exports